export default "__VITE_ASSET__6fc3d35d__"